module.exports = __webpack_public_path__ + "static/img/ptfw_abzbwzcg_two.cea99df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ptfw_abzbwzcg_two.png
// module id = zpbL
// module chunks = 21